// extracted by mini-css-extract-plugin
export default {"btn":"SideBarBtn_btn__or+cY"};